<template>
	<div class="about" id="dianziyouxiang">
		<div class="imgs" :class="index_about?'on':''" @mouseenter="index_about=true">
			<img src="@/assets/img/headerA.png" class="img img1" alt="">
			<img src="@/assets/img/headerA2.png" class="img img2" alt="">
		</div>
		<div class="name name_name">#{{$t('关于我们')}}</div>
		<div class="xiazai wow bounce" :class="$i18n.locale" data-wow-offset="120" data-wow-duration="1s" data-wow-delay="0s">{{$t('下载我们的招生简章')}}</div>
		<div class="form">
			<div class="input">
				<input type="number" class="text" v-model="mobile" maxlength="11" :placeholder="$t('手机号')">
			</div>
			<div class="tijiao" @click="post_tel">{{$t('提交')}}</div>
		</div>
		
		<!-- 招生简章弹窗 -->
		<el-dialog title="招生简章" :visible.sync="showBrochureDialog" width="500px" center>
			<div class="brochure-list">
				<a v-for="(item, index) in brochureList" :key="index" :href="item.url" target="_blank" class="brochure-item">
					<i class="el-icon-document"></i>
					<span>{{ item.name }}</span>
				</a>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: 'banner',
	props: {
		left: {
			type: String,
			default:''
		},
		right: {
			type: String,
			default:''
		},
		img_src: {
			type: String,
			default:''
		},
		name: {
			type: String,
			default:''
		},
		miaoshu: {
			type: String,
			default:''
		},
		path: {
			type: String,
			default:''
		},
	},
	data(){
		return{
			mobile:'',
			index_about:false,
			showBrochureDialog: false,
			brochureList: [],
		}
	},
	mounted(){
		const bserver = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('active');
				}else{
					entry.target.classList.remove('active');
				}
			});
		}, {
			threshold: 0.3,
		});
		const index_about = document.querySelector('.about');
		if (index_about) {
			bserver.observe(index_about);
		}
	},
	methods:{
		click_banner(name){
			this.$emit('callback',name);
		},
		post_tel(){
			if(!this.mobile){
				this.$message.error(this.$t('请输入手机号'));
				return
			}
			this.$post('website/ClientWebsite/add',{name:'招生简章',mobile:this.mobile,type:1,createtime:Math.round(new Date().getTime()/1000)}).then((res) => {
				const urlList = {
					'xiaoxue': 'https://api.bccsc.com.cn/uploads/mp4/小学简章.pdf',
					'chuzhong': 'https://api.bccsc.com.cn/uploads/mp4/初中简章.pdf',
					'gaozhong': 'https://api.bccsc.com.cn/uploads/mp4/高中简章.pdf',
				};
				
				// if (!urlList[this.path]) {
					// path 为空时，显示全部三个简章
					this.brochureList = [
						{ name: '小学招生简章', url: urlList.xiaoxue },
						{ name: '初中招生简章', url: urlList.chuzhong },
						{ name: '高中招生简章', url: urlList.gaozhong },
					];
					this.showBrochureDialog = true;
				// } else {
				// 	window.open(urlList[this.path]);
				// }
			})
		}
	}
}
</script>
<style scoped>
.brochure-list {
	display: flex;
	flex-direction: column;
	gap: 15px;
}
.brochure-item {
	display: flex;
	align-items: center;
	padding: 12px 15px;
	background-color: #f5f7fa;
	border-radius: 8px;
	text-decoration: none;
	color: #333;
	transition: all 0.3s ease;
}
.brochure-item:hover {
	background-color: #ecf5ff;
	color: #409eff;
	transform: translateX(5px);
}
.brochure-item i {
	font-size: 24px;
	margin-right: 10px;
}
.brochure-item span {
	font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/about.vue